import React, { Fragment } from 'react';
import FocusTrap from 'focus-trap-react';
import cn from 'classnames';
import { LABEL, CUSTOM_MESSAGES } from '@veriables';
import styles from './modal.module.css';
import { onKeyDown } from '../../../utility/utills';
import CrossIcon from '@assets/images/crossIcon';

const isMobile = window.innerWidth < 1023;
const waitlistCustomstyle = {
  width: '48%',
  margin: 'auto',
};
const Modal = ({
  isOpen, toggleModal, onConfirm, children, isLoyalty, customClass, retainModal, modalHideOverFlow, customStyle, mediumSize, modalBackground,
}) => {
  return (
    <FocusTrap
      active={isOpen || false}
      focusTrapOptions={{
        initialFocus: '#modal-container',
        escapeDeactivates: false,
        fallbackFocus: () => {
          return (
            <div tabIndex="-1" />
          );
        }
      }}
    >
      {/* eslint-disable-next-line */}
        <div className="W-100 m-auto" id="modal-container" tabIndex={-1} onKeyDown={(ev) => { if (toggleModal && ev.key === 'Escape') toggleModal(); }}>
          {!children ? (
            <div className={cn('modal', isOpen ? 'fade show d-block' : 'fade')}>
              <div className={cn('modal-dialog', mediumSize ? 'modal-md' : 'modal-lg', 'modal-dialog-centered')} role="document">
                <div className="modal-content">
                  <div className="card">
                    <div className="p-10 w-80">
                      <div className="col text-right btn-as-text color-secondary">
                        <div role="button" tabIndex={0} onKeyDown={e => onKeyDown(e, toggleModal)} onClick={toggleModal} aria-label="close" />
                        <CrossIcon active="od-iconStyles-actionIcons crossIconDefault" />
                      </div>
                    </div>
                    <div className="mx-0 justify-content-center align-items-center text-center">
                      <div className="fs-18 fw-600 text-center mt-10 p-10 pt-0">
                        {CUSTOM_MESSAGES().POPIN_CONFIRM_MSG}
                      </div>
                      <div className="row mt-20 mb-20 justify-content-center align-items-center text-center">
                        <button type="button" className="mr-20 btn btnLightSecondary col-4" onClick={toggleModal}>
                          {LABEL().NO}
                        </button>
                        <button type="button" className="ml-20 btn btnBlue col-4" onClick={onConfirm}>
                          {LABEL().YES}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Fragment>
              <div className={cn('modal', isOpen ? 'fade show d-block justify-content-center align-items-center m-auto' : 'fade', customClass, retainModal ? styles.retainModal : styles.popupFlow, isLoyalty && !isMobile && styles.Content)} data-backdrop="false">
                <div className={cn('modal-dialog', mediumSize ? 'modal-md' : 'modal-lg', 'modal-dialog-centered')} role="document">
                  <div className={cn(isMobile ? '' : styles.addressModal, 'modal-content w-80 od-bg-modal2', modalHideOverFlow ? styles.modalOverFlow : styles.modalContent, modalBackground)} style={(window.location.pathname === '/waitlist-confirmation' || window.location.pathname === '/manage-wait-list') && !isMobile ? waitlistCustomstyle : customStyle}>
                    {children}
                  </div>
                </div>
              </div>
            </Fragment>
          )}
        </div>
    </FocusTrap>
  );
};
export default Modal;
